export enum SecurityResponseMembershipOptions {
  AutoRenewal = 'autoRenewal',
  SendWelcomeEmail = 'sendWelcomeEmail',
  EmailOptOut = 'emailOptout',
}
